/**
 * Component Registry for Weidner Apartment Homes Theme
 * 
 * Extends the base comfy theme registry with Weidner Apartment Homes specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-comfy/registry';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { ApplyNow } from './components/ApplyNow';
import { PetPolicy } from './components/PetPolicy';
import { PricingVerbiage } from './components/PricingVerbiage';

/**
 * Weidner Apartment Homes specific component overrides.
 * These components have been customized for the Weidner Apartment Homes brand.
 */
const weidnerapartmenthomesOverrides: Partial<ComponentRegistry> = {
  Header,
  Footer,
  ApplyNow,
  PetPolicy,
  PricingVerbiage,
};

/**
 * Final merged registry for Weidner Apartment Homes properties.
 * Inherits all components from the comfy theme, with Weidner Apartment Homes overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...weidnerapartmenthomesOverrides,
};

export default registry;
